<template>
  <div class="setting-content--section">
    <div v-if="!loading" class="layouts-section">
      <div class="layouts-section--header">
        <div class="layouts-section--header__title">
          <h3>{{ $gettext('Custom layouts') }}</h3>
          <p>
            {{
              $gettext(
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum semper quam a rhoncus scelerisque.'
              )
            }}
          </p>
          <p class="text-warning" v-if="!currentCompany.is_premium">
            {{ $gettext('To manage and use different custom layouts, you have to be a Premium user.') }}
          </p>
        </div>
        <div>
          <GekkoButton
            @click="openLayoutCreate()"
            :text="$gettext('Add new layout')"
            :icon="'fa-solid fa-plus'"
            class="ml-auto mb-3"
          />
        </div>
      </div>
      <!-- <div class="layouts-wrap">
        <LayoutCard
          v-for="(layout, index) in availableLayouts"
          :key="'layout-' + index"
          :layout="layout"
          @click.native="openLayoutEdit(layout)"
        />
      </div> -->

      <LayoutBuilder
        @change="onChange"
      />
      
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import GekkoButton from '@/components/GekkoButton'

import LayoutCard from '@/components/layouts/LayoutCard'
import LayoutBuilder from '@/components/layouts/LayoutBuilder'

import settingsPageSetup from '@/mixins/settingsPageSetup'
import LoadingSpinner from '@/components/dashboard/ui/LoadingSpinner'
import ModalBase from '@/components/base_components/ModalBase'

export default {
  name: 'Layouts',
  components: {
    ModalBase,
    GekkoButton,
    LayoutCard,
    LayoutBuilder,
    LoadingSpinner,
  },
  mixins: [settingsPageSetup],
  data() {
    return {
      pageSettings: {
        title: this.$gettext('Layout builder'),
        showCompanyPicker: true,
      },
      showImportKvkModal: false,
      loading: true,
      availableLayouts: []
    }
  },
  computed: {
    ...mapGetters({
      currentCompany: 'main/getCurrentCompany'
    })
  },
  created() {
    this.setupData()
  },
  methods: {
    ...mapActions({
    }),
    setupData() {
      this.loading = true
      this.$nextTick(() => {
        this.loading = false
      })
    },
    openLayoutEdit(layout) {
      if (this.currentCompany.is_premium) {
        console.log('openLayoutEdit')
      } else {
        this.$store.commit('togglePremiumModal', 'web_layouts')
      }
    },
    openLayoutCreate() {
      if (this.currentCompany.is_premium) {
        console.log('openLayoutCreate')
      } else {
        this.$store.commit('togglePremiumModal', 'web_layouts')
      }
    },
    onEditedCallback() {
      this.setupData()
    },
    onCreatedCallback() {
      this.setupData()
    },
    onDeleteCallback() {
      this.setupData()
    },
    onChange(v) {
      console.log(v)
    }
  }
}
</script>
<style lang="scss">

</style>
<style scoped lang="scss">
.layouts-section {
  &:not(:last-child) {
    margin-bottom: 1rem;
  }
  &--header {
    &__title {
      max-width: 650px;
    }
    p {
      font-size: 0.875rem;
      opacity: 0.6;
    }
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    margin-bottom: 1rem;
    .btn-primary {
      width: 100%;
    }

    @media (min-width: 576px) {
      flex-direction: row;
      margin-bottom: 0;
      .btn-primary {
        width: auto;
      }
    }
  }
  .layouts-wrap {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1rem;
    @media (min-width: '1200px') {
      grid-template-columns: 1fr 1fr;
    }
  }
}
</style>
